import {ReactNode} from 'react';
import {toast} from 'react-hot-toast';

export const notify = (message: ReactNode, permanent?: boolean) => {
  const opts = permanent ? {duration: Infinity} : {};

  return toast(<div>{message}</div>, opts); // returns a unique id possible to use to manipulate the notification
};
